import PropTypes from 'prop-types';
import Endpoint from './Endpoint';

export default PropTypes.shape({
  uuid: PropTypes.string.isRequired,
  // user: PropTypes.string.isRequired, // it's always known
  // lang: PropTypes.string.isRequired, // the client need not to set it, the server will do it internally anyway

  image: PropTypes.string,

  completed: PropTypes.bool,
  approval: PropTypes.number,
  published: PropTypes.bool,

  tag1: PropTypes.string,
  tag2: PropTypes.string,
  tag3: PropTypes.string,
  tag4: PropTypes.string,
  tag5: PropTypes.string,

  guideName: PropTypes.string,
  guideDesc: PropTypes.string,
  guideImage: PropTypes.string,
  guideRating: PropTypes.number,
  guideReviews: PropTypes.number,

  name: PropTypes.string,
  desc: PropTypes.string,

  type: PropTypes.number,
  rentPrice: PropTypes.number,
  rentDays: PropTypes.number,
  buyPrice: PropTypes.number,
  promoted: PropTypes.bool,

  endpoints: PropTypes.arrayOf(Endpoint),
  endpointIds: PropTypes.string,
});
